export const hotelAddonTypes = {
  FETCH_TYPES: "FETCH_TYPES",
  FETCHING: "FETCHING",
  FETCH_ADDONS: "FETCH_ADDONS",
};
